<template>
  <div>
    <nav class=" py-2 px-2 md:px-0">
      <div class="flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <router-link :to="{name:'home'}">Home</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'organization', params: { orgId: orgId }}">organization
            </router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'venues'}">networks</router-link>
          </div>
          <div class="text-xl text-primary">
            Networks
          </div>
        </div>
        <div class="">
          <router-link v-if="$store.getters.can('create_networks')"
              class="py-1 px-2 md:py-2 md:px-4 bg-teal-500 md:font-semibold text-white hover:border-transparent hover:text-white hover:bg-teal-800 rounded float-right"
              :to="{name:'create_venue'}">
            New Network
          </router-link>
        </div>
      </div>
    </nav>
    <div class="py-4">
      <div class="bg-white pt-3 border rounded shadow-sm">
        <div class="my-2 mx-4 text-gray-800">Registered Networks</div>
        <div class="flex justify-between pt-2 px-3">
          <div>
            <label class="block tracking-wide text-gray-700">Records</label>
            <select v-model="recordsPerPage"
                    class="block appearance-none w-full bg-white border border-gray-300  px-4 py-2  rounded leading-tight focus:outline-none focus:border-gray-500">
              <option>1</option>
              <option>10</option>
              <option>25</option>
              <option>50</option>
              <option>100</option>
              <option>250</option>
            </select>
          </div>
          <div>
            <label class="block tracking-wide text-gray-700">Search</label>
            <input v-model="searchString" @change="loadStats(currentPage)"
                   class="appearance-none block w-full text-gray-700 border border-gray-300 rounded py-2 px-4 leading-tight focus:outline-none focus:border-gray-500"
                   type="text" placeholder="Search">
          </div>
        </div>
        <div class=" overflow-auto ">
          <table v-if="!loading" class="table-auto w-full">
            <thead>
            <tr class="text-left border-b">
              <th class="px-4 py-2"></th>
              <th class="px-4 py-2">Name</th>
              <th class="px-4 py-2">Address</th>
              <th class="px-4 py-2">Email</th>
              <th class="px-4 py-2">Phone number</th>
              <th class="px-4 py-2">Access points</th>
              <th class="px-4 py-2">Clients</th>                            
              <th class="px-4 py-2">Connections</th>
              <th class="px-4 py-2">Online</th>
            </tr>
            </thead>
            <tbody>
            <tr class="border-b hover:bg-gray-200" v-for="(venue, index) in organization.venues" :key="venue.id">
              <td class="px-3 py-2 font-bold">
                {{ offset + index + 1 }}
              </td>
              <td class="px-4 py-2 hover:text-blue-500">
                <router-link :to="{name: 'venue_details', params: {venueId: venue.id}}">{{ venue.name }}</router-link>
              </td>
              <td class="px-4 py-2">{{ venue.address }}</td>
              <td class="px-4 py-2">{{ venue.email }}</td>
              <td class="px-4 py-2">{{ venue.phone_number }}</td>
              <td class="px-4 py-2">{{ venue.accessPointsCount }}</td>
              <td class="px-4 py-2">{{ venue.customersCount }}</td>
              <td class="px-4 py-2">{{ venue.connectionsCount }}</td>
              <td class="px-4 py-2">{{ venue.onlineConnectionsCount }}</td>
            </tr>
            </tbody>
          </table>
          <div v-else class="py-6 text-center w-full">
            <feather animation="spin" type="loader" size="32" class="mr-4"></feather>
            <p>Loading...</p>
          </div>
        </div>
        <Pagination class="py-2 px-3" :total-count="organization.venuesCount" :current-page="currentPage"
                    :tag="'users'"
                    :offset="offset"
                    :records-count="organization.venues != null ? organization.venues.length || 0 : 0"
                    :click-handler="loadStats" :records-per-page="parseInt(recordsPerPage)"/>
      </div>
    </div>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import moment from "moment";
import GraphQl from "@/services/graphql.service";

export default {
  name: "Venues",
  components: {Pagination},
  data() {
    return {
      searchString: '',
      recordsPerPage: 10,
      organization: Object,
      orgId: this.$store.getters.orgId,
      currentPage: 1,
      loading: true
    }
  },
  props: {
    configs: Object
  },
  mounted() {
    this.loadStats();
  },
  watch: {
    recordsPerPage: function () {
      this.loadStats(this.currentPage)
    },
    searchString: function () {
      this.currentPage = 1;
    }
  },
  computed: {
    offset: function () {
      return (this.currentPage - 1) * this.recordsPerPage;
    }
  },
  methods: {
    formatDate(timestamp, format) {
      return moment(timestamp).format(format);
    },
    loadStats(newPage) {
      this.currentPage = newPage || 1;
      this.loading = true
      let params = 'limit: ' + this.recordsPerPage + ', offset: ' + this.offset + ', order: "name asc", search: "' + this.searchString + '"';
      GraphQl.sendRequest('{organization(id:"' + this.$store.getters.orgId + '") ' +
          '{venuesCount(' + params + ')' +
          ' venues(' + params + ') ' +
          '{id name phone_number email customersCount connectionsCount onlineConnectionsCount accessPointsCount customersCount}}}')
          .then(response => {
            this.organization = response.organization;
          })
          .finally(() => {
            this.loading = false;
          })
    }
  }
}
</script>
<style scoped>
</style>